import React from 'react';
import StarIcon from '@mui/icons-material/Star';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { Box } from '@mui/material';

interface StarRatingProps {
  rating: number; 
}

const StarRating: React.FC<StarRatingProps> = ({ rating }) => {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating - fullStars >= 0.5;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  return (
    <Box display="flex" alignItems="center" gap={0.3}>
      {Array.from({ length: fullStars }).map((_, i) => (
        <StarIcon key={`full-${i}`} fontSize="small" htmlColor="#FFD700" />
      ))}
      {hasHalfStar && <StarHalfIcon fontSize="small" htmlColor="#FFD700" />}
      {Array.from({ length: emptyStars }).map((_, i) => (
        <StarBorderIcon key={`empty-${i}`} fontSize="small" htmlColor="#FFD700" />
      ))}
    </Box>
  );
};

export default StarRating;